import { useState, useEffect } from 'react';
import { getApprovedTestimonials, Testimonial } from '../../../data/testimonialsData';
import TestimonialForm from './TestimonialForm';

export default function Testimonials() {
  const [testimonials, setTestimonials] = useState<Testimonial[]>([]);
  const [showForm, setShowForm] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    setTestimonials(getApprovedTestimonials());
  }, []);

  const handleFormSuccess = () => {
    setShowForm(false);
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 5000);
  };

  return (
    <section id="temoignages" className="py-24 bg-gradient-to-br from-gray-50 to-teal-50/30">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Avis Clients
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Découvrez ce que nos clients disent de nos services
          </p>
        </div>

        {testimonials.length === 0 ? (
          <div className="text-center py-12 text-gray-400 mb-12">
            <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
              <i className="ri-chat-quote-line text-5xl"></i>
            </div>
            <p className="text-lg font-medium">Soyez le premier à laisser un avis !</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
            {testimonials.map((testimonial) => (
              <div
                key={testimonial.id}
                className="bg-white rounded-xl p-8 shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
              >
                <div className="flex gap-1 mb-4">
                  {[...Array(5)].map((_, i) => (
                    <i
                      key={i}
                      className={`text-lg ${i < testimonial.rating ? 'ri-star-fill text-yellow-400' : 'ri-star-line text-gray-300'}`}
                    ></i>
                  ))}
                </div>
                <p className="text-sm text-gray-700 leading-relaxed italic mb-6">
                  &ldquo;{testimonial.text}&rdquo;
                </p>
                <div className="flex items-center gap-3 border-t border-gray-100 pt-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-teal-100 flex-shrink-0">
                    <i className="ri-user-line text-teal-600"></i>
                  </div>
                  <div>
                    <div className="text-sm font-bold text-gray-900">{testimonial.name}</div>
                    {testimonial.role && (
                      <div className="text-xs text-gray-500">{testimonial.role}</div>
                    )}
                    {testimonial.company && (
                      <div className="text-xs text-teal-600 font-medium">{testimonial.company}</div>
                    )}
                  </div>
                  <div className="ml-auto text-xs text-gray-400">{testimonial.date}</div>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* CTA laisser un avis */}
        <div className="text-center">
          {submitted ? (
            <div className="inline-flex items-center gap-3 bg-teal-50 border border-teal-200 text-teal-800 px-8 py-4 rounded-xl font-medium">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-checkbox-circle-line text-teal-600 text-xl"></i>
              </div>
              Merci pour votre avis ! Il sera publié après validation.
            </div>
          ) : !showForm ? (
            <button
              onClick={() => setShowForm(true)}
              className="inline-flex items-center gap-2 bg-teal-600 text-white px-8 py-4 rounded-xl font-medium hover:bg-teal-700 transition-colors shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-edit-line"></i>
              </div>
              Laisser un avis
            </button>
          ) : (
            <TestimonialForm
              onSuccess={handleFormSuccess}
              onCancel={() => setShowForm(false)}
            />
          )}
        </div>
      </div>
    </section>
  );
}
